import {
  GET_PRODUCT_TUTOR,
  SET_PAGE,
  SET_PRODUCT_ID,
  SET_SORT_BY,
  SET_ORDER_BY,
} from "../../shared/constants/ActionTypes";
import moment from "moment";

const initialProductTutor = {
  eh_productTutor: [],
  productTutorCount: 0,
  page: 1,
  courseId: "",
  orderby: "desc",
  sortby: "",
};

const productTutorReducer = (state = initialProductTutor, action) => {
  switch (action.type) {
    case GET_PRODUCT_TUTOR:
      return {
        ...state,
        eh_productTutor: action.payload.tutorDetails.map((tutor) => {
          return {
            ...tutor,

            updatedAtFormatted: moment(tutor.createdAt).format("ll"),

            tutorName: tutor?.firstName + " " + tutor?.lastName,
          };
        }),
        productTutorCount: action.payload.totalCount,
      };
    case SET_PAGE:
      return {
        ...state,
        page: action.payload,
      };

    // case SET_SEARCH:
    //   return {
    //     ...state,
    //     search: action.payload,
    //   };
    case SET_PRODUCT_ID:
      return {
        ...state,
        courseId: action.payload,
      };
    case SET_SORT_BY:
      return {
        ...state,
        sortby: action.payload,
      };
    case SET_ORDER_BY:
      return {
        ...state,
        orderby: action.payload,
      };
    default:
      return state;
  }
};

export default productTutorReducer;
